import React from 'react';
import { getCredentialingContracts } from 'api/credentialing';
import type { TCredentialingContract, TCredentialingContractView } from 'types/credentialing';

const globalDataMap: Record<string, TCredentialingContract[]> = {};

const useCredentialingContracts = (view: TCredentialingContractView = 'provider'): [TCredentialingContract[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TCredentialingContract[]>(globalDataMap[view] || []);

    const fetchData = React.useCallback(async () => {
        setLoading(true);
        try {
            const result = await getCredentialingContracts(view);
            if (result && !result.error) {
                const list: TCredentialingContract[] = result?.data?.data || [];
                globalDataMap[view] = list;
                setData(list);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [view]);

    React.useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data, loading, fetchData];
};

export default useCredentialingContracts;
